import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { DialogService, DialogStatus } from '../services/dialog.service';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  private dialogService = inject(DialogService);
  private translate = inject(TranslateService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    // مقدار پیش‌فرض تایم‌اوت
    let requestTimeout = 100_000;

    // اگر درخواست از نوع FormData بود، تایم‌اوت کمتر شود
    if (req?.body instanceof FormData) requestTimeout = 600_000;

    return next.handle(req).pipe(
      timeout(requestTimeout),
      catchError((err) => {
        if (err.name === 'TimeoutError') {
          const errMsg = this.translate.instant('messages.timeoutError');
          this.openErrorDialog('common.error', errMsg);
        }
        return throwError(() => err);
      }),
    );
  }

  openErrorDialog(
    title?: string,
    message?: string,
    status: DialogStatus = DialogStatus.error,
  ) {
    this.dialogService.openDialog({
      title,
      message,
      status,
    });
  }
}

export const TimeoutInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
];
